import {merge} from "lodash";
import partnerMessages from "@i18n_messages_pl"

export default merge({}, partnerMessages);